export default "__VITE_ASSET__08617311__"